globalThis.__HO_KITCHEN_ENV__ = {"BUN_PUBLIC_API_URL":"https://dev.api.horganic.com","BUN_PUBLIC_SUPABASE_ANON_KEY":"sb_publishable_uJvWpg6qDH_vXfAUimfC3Q_3BYA2Y1j","BUN_PUBLIC_SUPABASE_URL":"https://rmrpzebyhnjlbfynazru.supabase.co"};
